<template>
  <div>
    <section class="content-header">
      <h1>{{ item && item['name'] }}</h1>
    </section>

    <section class="content">
      <div class="box box-primary">
        <div class="box-body">
      <item-show-errors :entity="'category'" :is-loading="isLoading"></item-show-errors>

            <div v-if="item" class="table-responsive">
              <table class="table table-striped table-hover">
                <thead>
                <tr>
                  <th width="20%">{{$t('field')}}</th>
                  <th>{{$t('value')}}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>{{$t('category.name')}}</td>
                  <td>{{ translation(item).name }}</td>
                </tr>
                <tr>
                  <td>{{$t('category.parent.name')}}</td>
                  <td>
                    <router-link v-if="item['parent']" :to="{name: 'CategoryShow', params: { id: item['parent']['@id'] }}">
                      {{ item['parent']['name'] }}
                    </router-link>
                  </td>
                </tr>
                <tr>
                  <td>{{$t('category.createdAt')}}</td>
                  <td>{{ moment(item['createdAt']).format('DD-MM-YYYY HH:mm') }}</td>
                </tr>
                <tr>
                  <td>{{$t('category.updatedAt')}}</td>
                  <td>{{ moment(item['updatedAt']).format('DD-MM-YYYY HH:mm') }}</td>
                </tr>
                <tr>
                  <td>{{$t('category.updatedBy')}}</td>
                  <td>{{ item['updatedBy'] }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      <item-show-actions :item="item" :entity="'Category'" :path="'category'"></item-show-actions>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ItemShowActions from '../layout/ItemShowActions'
import ItemShowErrors from '../layout/errors/ItemShowErrors'

export default {
  components: {ItemShowErrors, ItemShowActions },
  data () {
    return {
      moment: moment
    }
  },
  computed: mapGetters({
    isLoading: 'category/show/isLoading',
    item: 'category/show/retrieved'
  }),

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      reset: 'category/show/reset',
      retrieve: 'category/show/retrieve'
    })
  }
}
</script>
